import { useCallback, useEffect, useMemo } from 'react'
import type { ReactNode } from 'react'
import { getIdentityFromSession, signOut } from '@/lib/auth'
import { useAuthStore } from '@/store/auth-store'
import { AuthContext } from '@/hooks/auth-context'

export function AuthProvider({ children }: { children: ReactNode }) {
  const identity = useAuthStore((state) => state.identity)
  const status = useAuthStore((state) => state.status)
  const setIdentity = useAuthStore((state) => state.setIdentity)
  const setStatus = useAuthStore((state) => state.setStatus)
  const clear = useAuthStore((state) => state.clear)

  const refresh = useCallback(async () => {
    setStatus('loading')
    try {
      const result = await getIdentityFromSession()
      setIdentity(result)
    } catch {
      clear()
    }
  }, [clear, setIdentity, setStatus])

  const logout = useCallback(async () => {
    await signOut()
    clear()
  }, [clear])

  useEffect(() => {
    void refresh()
  }, [refresh])

  const value = useMemo(
    () => ({ status, identity, refresh, logout }),
    [identity, logout, refresh, status]
  )
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}
